appComum.controller('DenunciasController', ['$scope', '$http', '$timeout', function ($scope, $http, $timeout) {

  // Inicializa model dos campos
  $scope.contact = {};
  $scope.contact.name = "";
  $scope.contact.email = "";
  $scope.contact.telefone = "";
  $scope.contact.subject = "";
  $scope.contact.message = "";

  constants.DENUNCIAS_MESSAGES = {
    DENUNCIAS_SUCCESS_MESSAGE: 'Sua mensagem foi enviada com sucesso. Em breve retornaremos o contato.'
  };

  // Salvar dados de formulario
  $scope.saveContact = function () {
    $scope.LOADING = true;

    $http({
      method: 'POST',
      url: '/api-web/comum/canal-denuncias/enviar',
      data: {
        "nome": $scope.contact.name == null? '': $scope.contact.name,
        "email": $scope.contact.email == null? '': $scope.contact.email,
        "telefone": $scope.contact.telefone == null? '': $scope.contact.telefone,
        "assunto": $scope.contact.assunto,
        "mensagem": $scope.contact.message
      },
      headers: {'Content-Type': 'application/json'}
    }).success(function (data, status, headers, config) {
      $scope.LOADING = false;
      
      if (data) {
        if (data.codigoResposta == 0) {
          resetForm();
          $scope.feedbacks = [{
            type: 'success', msg: constants.DENUNCIAS_MESSAGES.DENUNCIAS_SUCCESS_MESSAGE
          }];
        }
        else {
          $scope.feedbacks = [{
            type: 'danger', msg: constants.MESSAGES.DEFAULT_ERROR_MESSAGE
          }];
        }
      }
    }).error(function (data, status, headers, config) {
      $scope.LOADING = false;
      $scope.feedbacks = [{
        type: 'danger', msg: data.message
      }];
    });
  };

  if (constants.SETTINGS.DEBUG) {
    $scope.exposeScope('DenunciasController', $scope);
  }

  function resetForm() {
    $scope.contact = {};
    $scope.contactUs.$setPristine();
  }

}]);
